export const NameValidationNoSpace = /^[a-zA-ZÀ-ÖÙ-öù-ÿĀ-žḀ-ỿ\-/.]+$/;
export const PasswordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;
